export function getMentionName(firstName, lastName) {
    return `${firstName}${lastName ? ' ' + lastName.charAt(0)+"." : ''}`;
}
